<template>
    <div>
        <el-dialog
            :visible.sync="dateDetail.show"
            width="30%"
            append-to-body
            :show-close="true"
            :close-on-click-modal="false"
            class="booking-calendar-curier-more-detail-kan-style"
            >
            <el-row style="border-bottom: 1px solid #D0DADC;">
                <el-col :sapn="24">
                    <h2>{{dateDetail.date}}</h2>
                </el-col>
            </el-row>
            <el-row v-if="hasCourierDetail" style="padding-top: 10px;">
                <el-col :span="24">
                    <div
                    v-for="(item, index) in dateDetail.info"
                    :key="index"
                    class="booking-calendar-courier-detail-dialog-kan-style"
                    :style=" `--tooltip-color: ${item.backgroundColor};`"
                    @click="showDetailMore(item)">
                        <span style="color: #FFFFFF;">{{item.title}}</span>
                    </div>
                </el-col>
            </el-row>
             <el-row v-else style="padding-top: 10px;">
                <el-col :span="24">
                    <span>ไม่มีข้อมูล</span>
                </el-col>
            </el-row>
        </el-dialog>
        <el-dialog
            :visible.sync="dateDetailMore.show"
            width="50%"
            append-to-body
            :show-close="false"
            :close-on-click-modal="false"
            class="booking-calendar-curier-more-detail-kan-style"
            >
            <el-row>
                <el-col :span="24" class="text-center">
                    <span class="font-sarabun-kan-style font-size-20-kan-style booking-calendar-courier-dialog-header-kan-style">{{couierDetailType}} {{couierDetailHeader}}</span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" class="text-center">
                    <el-table
                        :data="dateDetailMore.info"
                        class="booking-calendar-courier-detail-table-kan-style"
                        :header-cell-style="{'font-family':'Sarabun', 'font-size': '14px','font-weight':'Medium', 'color': '#2C3E50'}"
                    >
                        <el-table-column
                            property="shopName"
                            header-align="left"
                            align="left"
                            label="ชื่อร้าน"
                            width="200">
                            <template slot-scope="props">
                                <div v-for="(shop,index) in shopNameLineBreak(props.row.shopName)" :key="index">{{shop}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="amountOrder"
                            header-align="center"
                            align="center"
                            label="ออเดอร์">
                        </el-table-column>
                        <el-table-column
                            prop="type"
                            header-align="center"
                            align="center"
                            label="ประเภทการเข้ารับ">
                        </el-table-column>
                        <el-table-column
                            prop="pickupTime"
                            header-align="center"
                            align="center"
                            label="เวลา">
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <span slot="footer" class="booking-calendar-courier-detail-dialog-footer-kan-style">
                <el-button
                    type="primary"
                    style="max-width: 150px; min-width: 150px;"
                    @click="dateDetailMore.show = false">
                    <span class="font-sarabun-kan-style font-size-18-kan-style">ปิด</span>
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import { sync } from 'vuex-pathify'
// dayjs
import 'dayjs/locale/th'

export default {
    name: 'BookingCalendarCourierDetailDialog',
    props: {
        dateDetail: {
            type: Object,
            default: () => {
                return {
                    show: false,
                    date: '',
                    info: []
                }
            }
        }
    },
    data () {
        return {
            couierDetailHeader: '',
            couierDetailType: '',
            dateDetailMore: {
                show: false,
                date: '',
                info: []
            }
        }
    },
    computed: {
        ...sync('booking/*'),
        hasCourierDetail () {
            return this.dateDetail.info.length > 1
        }
    },
    methods: {
        shopNameLineBreak (shop) {
            let shopList = shop.split(', ')
            return shopList
        },
        calendarTypeFilter (id) {
            switch (id) {
            case 1:
                this.couierDetailType = 'ส่งประจำครั้งแรก'
                break
            case 2:
                this.couierDetailType = 'ส่งครั้งเดียว'
                break
            case 3:
                this.couierDetailType = 'ส่งประจำ'
                break
            case 4:
                this.couierDetailType = 'ส่งประจำหยุด'
                break
            default:
                return ''
            }
        },
        async showDetailMore (info) {
            try {
                this.calendarTypeFilter(info.type)
                let param = {
                    search_value: this.bookingCalendarSearch,
                    courier_id: info.id,
                    calendar_type: info.type,
                    start_date: info.start,
                    booking_types: info.bookingType,
                    pickup_address_ids: info.pickUpAddressId,
                    weekday: info.weekday

                }
                let res = await fgApi.courier.getGropShopBookingCalendar(param)
                this.dateDetailMore.info = []
                if (res.success) {
                    for (let key in res.data) {
                        let status = ''
                        let e = res.data[key]
                        if (e.type === 3) {
                            let array = []
                            e.pickupDay.forEach(day => {
                                let weekday = this.$dayjs().locale('th').set('day', day).format('dddd')
                                array.push(` ${weekday}`)
                            })
                            status = String(array)
                        } else {
                            if (e.type === 1) {
                                status = 'จันทร์-เสาร์'
                            } else if (e.type === 2) {
                                status = 'จันทร์-ศุกร์'
                            } else if (e.type === 4) {
                                status = 'ครั้งเดียว'
                            }
                        }
                        let data = {
                            shopName: e.shopName,
                            amountOrder: e.countOrder,
                            courierBookingId: e.courierBookingId,
                            courierId: e.courierId,
                            pickupTime: e.pickupTime,
                            type: status
                        }
                        this.couierDetailHeader = e.courierName
                        this.dateDetailMore.info.push(data)
                    }
                    this.dateDetail.show = false
                    this.dateDetailMore.show = true
                } else {
                    this.$message.error('Api get data failed')
                }
            } catch (error) {
                this.$message.error(`Oops, Api is ${error} !`)
            }
        }
    }
}
</script>
<style lang="scss">
    .booking-calendar-courier-detail-dialog-footer-kan-style{
        display: flex;
        justify-content: center;
    }
    .booking-calendar-courier-dialog-header-kan-style{
        color:#2C3E50;
        font-weight: bold;
    }
    .booking-calendar-courier-detail-table-kan-style{
        color: #676767;
        font-family: Sarabun;
        font-size: 14px;
        width: 100%;
        max-height: 357px;
        overflow-y: scroll;
    }
    .booking-calendar-curier-more-detail-kan-style{
        .el-dialog{
            .el-dialog__header{
                padding: 0;
            }
            // .el-dialog__body{
            //     padding: 0;
            // }
        }
    }
    .booking-calendar-courier-detail-dialog-kan-style{
        background-color: var(--tooltip-color);
        border: 1px solid #FFFFFF;
        border-radius: 5px;
        padding-left: 10px;
    }
    /* .test{
        background-color: #00A8A4;
    } */
    // ::-webkit-scrollbar {
    //    width: 10px;
    // }

// /* Track */
// ::-webkit-scrollbar-track {
//   background: #f1f1f1;
// }

// /* Handle */
// ::-webkit-scrollbar-thumb {
//   background: #888;
// }

// /* Handle on hover */
// ::-webkit-scrollbar-thumb:hover {
//   background: #555;
// }
</style>
